import { Button, Input, Modal, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import VehicleServices from "../../../services/vehicle.services";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import TmsPrintTicket from "../../../components/tms-print-ticket/tms-print-ticket";
import moment from "moment";

const PosVehiclePass = ({ router }) => {
  const [vehicleNo, setVehicleNo] = useState("");
  const [accessGate, setAccessGate] = useState("");
  const [department, setDepartment] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [accessGates, setAccessGates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [array, setArray] = useState([]);
  const [externalPrint, setExternalPrint] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const printTicket = (data) => {
    setArray([
      ["Date", moment(data?.createdAt).format("DD-MM-YYYY"), { margin: "0" }],
      ["Vehicle No", data?.vehicleNo, { margin: "0" }],
      ["Department Name", data?.departmentId, { margin: "0" }],
      ["Access Gate", data?.accessGateId, { margin: "0" }],
      ["footer", data?.transactionId, {}, {}, {}, null, data?.createdAt],
    ]);
  };

  const handleCancel = () => {
    setVehicleNo("");
    setAccessGate("");
    setDepartment("");
    setSubmitLoading(false);
  };

  const handleSubmit = async () => {
    if (buttonLoading) return;
    setSubmitLoading(true);
    try {
      let data = await VehicleServices.createVehiclePass({
        vehicleNo: vehicleNo,
        departmentId: department,
        accessGateId: accessGate,
      });
      printTicket(data);
      setIsModalVisible(true);
      setExternalPrint(true);
      handleCancel();
      fetchVehiclePasses();
    } catch (error) {
      catchErrorFunction(error, "Failed to create walker tag serials", router);
    } finally {
      setSubmitLoading(false);
    }
  };

  const fetchVehiclePasses = async () => {
    setLoading(true);
    try {
      const response = await VehicleServices.getAllVehiclePass();
      setTableData(response);
      setLoading(false);
    } catch (error) {
      catchErrorFunction(error, "Failed to fetch access gates", router);
      setLoading(false);
    }
  };

  const fetchAccessGates = async () => {
    setLoading(true);
    try {
      const response = await VehicleServices.getAccessGates();
      setAccessGates(response);
      setLoading(false);
    } catch (error) {
      catchErrorFunction(error, "Failed to fetch access gates", router);
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const response = await VehicleServices.getDepartments();
      setDepartments(response);
      setLoading(false);
    } catch (error) {
      catchErrorFunction(error, "Failed to fetch access gates", router);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehiclePasses();
    fetchAccessGates();
    fetchDepartments();
  }, []);

  const columns = [
    {
      title: "Vehicle No",
      dataIndex: "vehicleNo",
      key: "vehicleNo",
    },
    {
      title: "Access Gate",
      dataIndex: "accessGate",
      key: "accessGate",
      render: (_, record) => record.accessGate.name,
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      render: (_, record) => record.department.departmentName,
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      key: "transactionId",
    },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   key: "action",
    //   render: (_, record) => (
    //     <Button
    //       type="primary"
    //       onClick={() => {
    //         // Handle edit action
    //       }}
    //     >
    //       Edit
    //     </Button>
    //   ),
    // },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <label style={{ textAlign: "left" }}>Vehicle No</label>
          <Input
            placeholder="Vehicle No"
            onChange={(e) => setVehicleNo(e.target.value)}
            value={vehicleNo}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            width: "20%",
          }}
        >
          <label style={{ textAlign: "left" }}>Access Gate</label>
          <Select
            style={{ width: "100%" }}
            placeholder="Access Gate"
            onChange={(e) => setAccessGate(e)}
            value={accessGate}
          >
            {accessGates.map((accessGate) => (
              <Select.Option key={accessGate.id} value={accessGate.id}>
                {accessGate.name}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            width: "20%",
          }}
        >
          <label style={{ textAlign: "left" }}>Department</label>
          <Select
            style={{ width: "100%" }}
            placeholder="Department"
            onChange={(e) => setDepartment(e)}
            value={department}
          >
            {departments.map((department) => (
              <Select.Option key={department.id} value={department.id}>
                {department.departmentName}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button type="primary" onClick={handleSubmit} loading={submitLoading}>
          Submit
        </Button>
      </div>
      <br />

      <div>
        <Table
          dataSource={tableData}
          loading={loading}
          columns={columns}
          pagination={false}
        />
      </div>
      <Modal
        visible={isModalVisible}
        width={450}
        footer={null}
        closable={false}
        centered
        maskClosable={false}
      >
        <TmsPrintTicket
          data={array}
          setData={setArray}
          type="Vehicle Pass"
          from="Counter"
          externalPrint={externalPrint}
          setExternalPrint={setExternalPrint}
          setButtonLoading={setButtonLoading}
          setPrintTicketModal={setIsModalVisible}
          ticketType={""}
        />
      </Modal>
    </div>
  );
};

export default PosVehiclePass;
